import { Typography } from "@mui/material";
import classNames from "classnames";
import { Link, useLocation } from "react-router-dom";

import { ERole } from "../../../@types";
import { useAccount } from "../../../hooks/useAccount";
import { Container } from "../../common/Container/Container";
import { Account } from "./components/Account/Account";
import { Profile } from "./components/Profile/Profile";
import { Safety } from "./components/Safety/Safety";

import "./about_me.scss";

export function AboutMe() {
	const { account, signOut } = useAccount();

	const location = useLocation();
	const isAccount = location.pathname.startsWith("/about-me/account");
	const isProfile = location.pathname.startsWith("/about-me/profile");
	const isSafety = location.pathname.startsWith("/about-me/safety");

	if (!account) {
		return null;
	}

	return (
		<Container className="about-me-container">
			<div className="about-me-content-container">
				<div className="left-column">
					<Link to="/about-me/account" className="no-underline-link black-text">
						<Typography
							className={classNames("menu-button normal-text bold", {
								selected: isAccount,
							})}>
							Account
						</Typography>
					</Link>
					<Link to="/about-me/profile" className="no-underline-link black-text">
						<Typography
							className={classNames("menu-button normal-text bold", {
								selected: isProfile,
							})}>
							Profile
						</Typography>
					</Link>
					<Link to="/about-me/safety" className="no-underline-link black-text">
						<Typography
							className={classNames("menu-button normal-text bold", {
								selected: isSafety,
							})}>
							Safety
						</Typography>
					</Link>
					{account.role === ERole.STUDENT && (
						<Link
							to="/become-instructor"
							className="no-underline-link black-text">
							<Typography
								className="menu-button normal-text bold"
								width="fit-content">
								Become Instructor
							</Typography>
						</Link>
					)}
					<Link to="/" className="underline-link black-text" onClick={signOut}>
						<Typography
							className="menu-button normal-text bold"
							width="fit-content">
							Sign Out
						</Typography>
					</Link>
				</div>
				<div className="right-column">
					{isAccount && <Account />}
					{isProfile && <Profile />}
					{isSafety && <Safety />}
				</div>
			</div>
		</Container>
	);
}
